import { EventEmitter, Injectable, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()

export class EODrawerService {
    private _loading = new BehaviorSubject<boolean>(false);
    public readonly loading$ = this._loading.asObservable();
    public EstimationOrderId: string;
    @Output() event_callback: EventEmitter<any> = new EventEmitter();
    show() {
        console.log("Is these line running**", this.EstimationOrderId);
        this.event_callback.emit(this.EstimationOrderId);
        this._loading.next(true);
    }
    hide() {
        this._loading.next(false);
    }
}
